import { Button } from "../../Button";
import Lottie from "lottie-react";
import thumbsUpAnimation from "../../../lottie/Animation - 1701770150315.json";
import { useState } from "react";

interface Props {
    onClose: () => void;
    selection: any[];
}

export default function SuccessOnboarding({ onClose, selection }: Props) {
    return (
        <div className="flex flex-col md:flex-row items-center justify-center min-h-full p-4 md:p-8">
            {/* Image Section */}
            <div className="w-full md:w-1/2 lg:w-2/5 h-64 md:h-auto bg-center bg-cover bg-[url('/public/images/onboarding-roadmap-2.gif')] mb-4 md:mb-0 md:mr-4 rounded-lg shadow-md">
                {/* This div is purely for the background image */}
            </div>
            {/* Lottie and Button Section */}
            <div className="w-full md:w-1/2 lg:w-3/5 flex flex-col items-center justify-center text-center">
                <Lottie
                    loop={false}
                    animationData={thumbsUpAnimation}
                    className="w-60 md:w-80" // Responsive Lottie size
                />
                <div className="mt-4 md:mt-8"> {/* Reduced top margin for the button */}
                    <Button onClick={onClose} type="pink">
                        Afronden
                    </Button>
                </div>
            </div>
        </div>
    );
}
